module.exports = __webpack_public_path__ + "img/icone-pdf.015bb448.png";